import { defineNuxtPlugin } from '#app/nuxt'
import { LazySaferGamblingApp, LazySaferGamblingArchive, LazySaferGamblingArchivePanel, LazySaferGamblingEntrance, LazySaferGamblingEntrancePanel, LazySaferGamblingFooter, LazySaferGamblingQaContent, LazySaferGamblingQaPanel, LazySaferGamblingSearch, LazySaferGamblingSubPanel, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl } from '#components'
const lazyGlobalComponents = [
  ["SaferGamblingApp", LazySaferGamblingApp],
["SaferGamblingArchive", LazySaferGamblingArchive],
["SaferGamblingArchivePanel", LazySaferGamblingArchivePanel],
["SaferGamblingEntrance", LazySaferGamblingEntrance],
["SaferGamblingEntrancePanel", LazySaferGamblingEntrancePanel],
["SaferGamblingFooter", LazySaferGamblingFooter],
["SaferGamblingQaContent", LazySaferGamblingQaContent],
["SaferGamblingQaPanel", LazySaferGamblingQaPanel],
["SaferGamblingSearch", LazySaferGamblingSearch],
["SaferGamblingSubPanel", LazySaferGamblingSubPanel],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
